/** Bump when shipping client-facing bundle changes (forces one reload on mobile). */
export const APP_VERSION = '29';

/** Owner register form — wheeled/tracked + excavator invoice */
export const REGISTRATION_FORM_VERSION = '3b-crawler-types';

/** Shown in premium PDF footers — confirms new generator ran. */
export const PDF_ENGINE_VERSION = 'premium-2026-05-30';
